import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, isRef as _isRef } from "vue";

import { ref, watch } from 'vue';
const _hoisted_1 = {
  class: "ul-error-list"
};
export default /*@__PURE__*/_defineComponent({
  __name: 'error',
  props: {
    errors: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const props = __props;
    const tab = ref('0');
    const errorList = ref([]);
    watch(() => props.errors, newVal => {
      errorList.value = filterErrors(newVal);
    }, {
      immediate: true
    });
    function filterErrors(errors) {
      if (!errors) {
        return [];
      }
      return errors.filter(e => e.sheetName && e.cellErrors && e.cellErrors.length > 0);
    }
    return (_ctx, _cache) => {
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createBlock(_component_el_tabs, {
        modelValue: _unref(tab),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(tab) ? tab.value = $event : null)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errorList), (sheet, index) => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: sheet.sheetName,
            label: `${sheet.sheetName}(${sheet.cellErrors.length})`,
            name: index.toString()
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_scrollbar, null, {
              default: _withCtx(() => [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sheet.cellErrors, (cell, eIndex) => {
                return _openBlock(), _createElementBlock("li", {
                  key: eIndex,
                  style: {
                    "line-height": "28px"
                  }
                }, " 第" + _toDisplayString(cell.rowNumber + 1) + "行，第" + _toDisplayString(cell.columnNumber + 1) + "列：" + _toDisplayString(cell.message), 1);
              }), 128))])]),
              _: 2
            }, 1024)])]),
            _: 2
          }, 1032, ["label", "name"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});